import HttpError from 'core/exceptions/httpError';

export default class HttpServerError extends HttpError {}
